import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App.js';
import { queryClient } from './lib/queryClient.js';
import { PortalProvider } from './portal/PortalContext.js';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <PortalProvider>
          <App />
        </PortalProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
